import { WatermarkElementTypes, type IWatermarkSet } from '@/types/watermarks.types';

/**
 *
 * This file is for testing purposes only just to handle rendering the canvas
 *
 */

export const defaultWatermark: IWatermarkSet = {
  id: 0,
  uuid: '',
  channel: 0,
  name: 'Test Watermark',
  elements: [
    {
      uuid: '001',
      type: WatermarkElementTypes.email,
      settings: {
        text: {
          font: {
            url: 'https://uploads.brandlive-dev.com/512db281-bf0a-4258-8efa-f56ff9644c6c/1762964052234/TradeGothicforNike365-BdCn.ttf',
            name: 'Trade Gothic for Nike 365 BdCn__custom-6__',
          },
          font_size: 48,
          color: '#ffffff',
          value: 'adam@brandlive.com',
        },
        image: {
          original_url:
            'https://uploads.brandlive-dev.com/filtered-images/ff0a7be8-af50-40bd-87cc-5a6a43d97ed1/c7b27b803d25d209637a62804962f937b7c6be8b.png',
          url: 'https://uploads.brandlive-dev.com/filtered-images/ff0a7be8-af50-40bd-87cc-5a6a43d97ed1/c7b27b803d25d209637a62804962f937b7c6be8b.png',
        },
        dimensions: {
          x: 500,
          y: 500,
          scale: 3,
          rotation: 0,
        },
        repeat: false,
        duration: '',
      },
    },
    {
      uuid: '002',
      type: WatermarkElementTypes.date,
      settings: {
        text: {
          font: {
            url: 'https://uploads.brandlive-dev.com/512db281-bf0a-4258-8efa-f56ff9644c6c/1762963696590/Space-Rabbit.otf',
            name: 'Space Rabbit__custom-0__',
          },
          font_size: 48,
          color: '#ffffff',
          value: '',
        },
        image: {
          original_url: '',
          url: '',
        },
        dimensions: {
          x: 500,
          y: 600,
          scale: 1,
          rotation: 0,
        },
        repeat: true,
        duration: '',
      },
    },
    {
      uuid: '006',
      type: WatermarkElementTypes.time,
      settings: {
        text: {
          font: {
            url: 'https://uploads.brandlive-dev.com/512db281-bf0a-4258-8efa-f56ff9644c6c/1762963696590/Space-Rabbit.otf',
            name: 'Space Rabbit__custom-0__',
          },
          font_size: 48,
          color: '#ffffff',
          value: '',
        },
        image: {
          original_url: '',
          url: '',
        },
        dimensions: {
          x: 1000,
          y: 100,
          scale: 1,
          rotation: 0,
        },
        repeat: true,
        duration: '',
      },
    },
    {
      uuid: '003',
      type: WatermarkElementTypes.image,
      settings: {
        text: {
          font: {
            url: '',
            name: '',
          },
          font_size: 0,
          color: '',
          value: '',
        },
        image: {
          original_url:
            'https://image.videodelivery.brandlive-staging.com/NYettgulCw7FtR3NidUp02UU9ptVwJutGsBy5wKjD8BY/thumbnail.webp',
          url: 'https://image.videodelivery.brandlive-staging.com/NYettgulCw7FtR3NidUp02UU9ptVwJutGsBy5wKjD8BY/thumbnail.webp',
          opacity: 0.25,
        },
        dimensions: {
          x: 100,
          y: 200,
          scale: 1,
          rotation: 25,
          height: 400,
          width: 400,
        },
        repeat: true,
        duration: '',
      },
    },
    {
      uuid: '004',
      type: WatermarkElementTypes.custom,
      settings: {
        text: {
          font: {
            url: 'https://uploads.brandlive.com/ea7441c0-8d86-4b47-b73f-b9de8ff62e3d/1695236080132/Chivo-Regular.ttf',
            name: 'Chivo',
          },
          font_size: 48,
          color: '#ffffff',
          value: 'Beep and boop',
        },
        image: {
          original_url: '',
          url: '',
        },
        dimensions: {
          x: 100,
          y: 100,
          scale: 1,
          rotation: 0,
        },
        repeat: false,
        duration: '',
      },
    },
    {
      uuid: '009',
      type: WatermarkElementTypes.image,
      settings: {
        text: {
          font: {
            url: '',
            name: '',
          },
          font_size: 0,
          color: '',
          value: '',
        },
        image: {
          original_url:
            'https://image.videodelivery.brandlive-staging.com/NYettgulCw7FtR3NidUp02UU9ptVwJutGsBy5wKjD8BY/thumbnail.webp',
          url: 'https://image.videodelivery.brandlive-staging.com/NYettgulCw7FtR3NidUp02UU9ptVwJutGsBy5wKjD8BY/thumbnail.webp',
          opacity: 0.25,
        },
        dimensions: {
          x: 100,
          y: 200,
          scale: 1,
          rotation: 25,
          height: 400,
          width: 400,
        },
        repeat: false,
        duration: '',
      },
    },
  ],
};

export const TILE_PADDING = 40;
